module.exports = __webpack_public_path__ + "img/fun7.764f8dc1.png";